"use client";

import { useTranslations } from "next-intl";

import { SignInForm } from "@/components/auth/SignInForm";
import { Dialog } from "@/components/shared/Dialog";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LoginModal({ isOpen, onClose }: LoginModalProps) {
  const t = useTranslations("signIn");

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={t("heading")} description={t("subhead")}>
      <SignInForm />
    </Dialog>
  );
}
